import React, { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Typography, Button } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from '../components/SuccessModal';
import { useNavigate } from 'react-router-dom';
import { SelledProducts } from '../components/datatables/index';
import { SecondaryButton, PrimaryLightSelect } from '../theme/index';
import AddIcon from '@mui/icons-material/Add';
import { modalAction } from '../redux/reducers/Modal'

const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const SellProductDetail = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();

  const [ showModal, setShowModal ] = useState(false);
  const [ payedStatus, setPayedStatus ] = useState('not-payed');

  useEffect( () => {
    setShowModal(modalStatus);
  }, [modalStatus] );

  const changePayedStatus = (value) => {
    setPayedStatus(value);
  }

  const tablesTitle = () => {
    return ( screenWidth <= 500 ) ? { fontSize: '1.5rem', fontFamily: 'Roboto-Bold'  } : { fontSize: '2rem', fontFamily: 'Roboto-Bold'  };
  }
  
  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Venta de productos</h2>
      </Grid>
      {
        showModal &&
          <SuccessModal view='productList' />
      }

      <Grid container sx={{ mt: 5, justifyContent: 'space-between', mb: 8 }}>
        <Grid item xs={12} md={3} sx={ (theme) => ({
            color: '#000', mb: 4, border: `1px solid ${theme.palette.primary.main}`
        }) } onClick={ () => alert('Go to this reservation checkout') }>
          <Typography sx={{ backgroundColor: 'primary.light', width: '100%', my: 0, textAlign: 'center', 
                            py: .5, color: '#FFF', fontSize: '1.5rem', fontFamily: 'Roboto-Bold' }}>
            Cliente 
          </Typography>
          <div style={{ alignItems: 'center', padding: '1.5rem 0' }}>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Nombre: Alejandro Perez 
            </Typography>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Tipo documento: Pasaporte
            </Typography>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Documento: 000.000.000
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={3} sx={ (theme) => ({
            color: '#000', mb: 4, border: `1px solid ${theme.palette.primary.main}`
        }) } onClick={ () => alert('Go to this reservation checkout') }>
          <Typography sx={{ backgroundColor: 'primary.light', width: '100%', my: 0, textAlign: 'center', 
                            py: .5, color: '#FFF', fontSize: '1.5rem', fontFamily: 'Roboto-Bold' }}>
            Habitación 
          </Typography>
          <div style={{ alignItems: 'center', padding: '1.5rem 0' }}>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Número habitación: 010
            </Typography>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Tipo habitación: Suite
            </Typography>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Costo por día: $160
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12}  md={3} sx={ (theme) => ({
            color: '#000', mb: 4, border: `1px solid ${theme.palette.primary.main}`
        }) } onClick={ () => alert('Go to this reservation checkout') }>
          <Typography sx={{ backgroundColor: 'primary.light', width: '100%', my: 0, textAlign: 'center', 
                            py: .5, color: '#FFF', fontSize: '1.5rem', fontFamily: 'Roboto-Bold' }}>
            Reserva 
          </Typography>
          <div style={{ alignItems: 'center', padding: '1.5rem 0' }}>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Entrada: 14/07/2022 16:13:11
            </Typography>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Salida: 15/07/2022 10:35:52
            </Typography>
            <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Tiempo calculado: 1 día, 18 horas
            </Typography>
          </div>
        </Grid>

      </Grid>

      <Grid item xs={12} sx={ (theme) => ({ px: 2, py: 1, backgroundColor: 'primary.light' }) }>
        <Grid container sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
          <Grid item xs={12} md={3} sx={{textAlign: 'center', mb: 2 }}>
            <SecondaryButton sx={{ textTransform: 'none', px: 8 }} onClick={ () => dispatch(modalAction()) }><AddIcon /> Agregar productos</SecondaryButton>
          </Grid>
          <Grid item xs={12} md={3} sx={{textAlign: 'center', mb: 2 }}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <PrimaryLightSelect 
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                value={ payedStatus }
                onChange={ e => changePayedStatus(e.target.value) }
                sx={{ backgroundColor: 'secondary.light', color: '#FFF' }}
              >
                  <MenuItem value='payed'>Pagado</MenuItem>
                  <MenuItem value='not-payed'>Falta pagar</MenuItem>
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} sx={{textAlign: 'center', mb: 2 }}>
            <SecondaryButton sx={{ textTransform: 'none', px: 8 }}>Terminar venta</SecondaryButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mb: 5 }}>
        <SelledProducts />
      </Grid>
    </Grid>
  )
}

export default SellProductDetail